import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=4a0804ec"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0804ec')) {
      api.createRecord('4a0804ec', component.options)
    } else {
      api.reload('4a0804ec', component.options)
    }
    module.hot.accept("./Teams.vue?vue&type=template&id=4a0804ec", function () {
      api.rerender('4a0804ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Teams.vue"
export default component.exports